import axios from "axios";
import { getTokenData } from "../../../shared/utils/utils";

const pickPublicUrl = (payload) => {
  if (!payload || typeof payload !== "object") return "";

  const direct =
    payload.url ||
    payload.public_url ||
    payload.publicUrl ||
    payload.file_url ||
    payload.fileUrl ||
    payload.location ||
    "";

  if (direct) return String(direct);

  const nested = payload.data && typeof payload.data === "object" ? pickPublicUrl(payload.data) : "";
  if (nested) return nested;

  const result = payload.result && typeof payload.result === "object" ? pickPublicUrl(payload.result) : "";
  if (result) return result;

  return "";
};

export async function UploadTemplateMedia(file) {
  const { token, client_id } = await getTokenData();

  if (!token) throw new Error("Token de autenticação não encontrado");
  if (!client_id) throw new Error("ID do cliente não encontrado");
  if (!file) throw new Error("Arquivo não informado");

  const formData = new FormData();
  formData.append("file", file);

  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_AWS_URL}/templates/file`,
    formData,
    {
      headers: {
        Authorization: token,
        Client_ID: client_id,
      },
    },
  );

  const publicUrl = pickPublicUrl(response?.data);
  if (!publicUrl) {
    throw new Error("URL pública não retornada pelo upload");
  }

  return publicUrl;
}
